import { Button, ErrorNotice } from '@bcecloud/portal-ui';
import { errorMessage } from '@/lib/api';
import { REP_WRITE_REFUSAL, writeRefusal } from '@/lib/sales-workspace';

/**
 * Why a write did not happen, inside the dialog that tried it. A stale edit
 * offers a reload; every other refusal reads as the server's own sentence.
 *
 * @param props - The failed mutation's error, and a reload for a stale edit.
 * @returns The notice.
 */
export function WriteError({
  error,
  onReload,
}: {
  readonly error: unknown;
  readonly onReload?: () => void;
}): React.ReactElement {
  const stale = writeRefusal(error) === REP_WRITE_REFUSAL.stale;
  return (
    <ErrorNotice
      inline
      tone={stale ? 'warning' : 'danger'}
      title={stale ? 'Changed in Salesforce.' : 'Not saved.'}
      message={errorMessage(error)}
      action={
        stale && onReload ? (
          <Button variant="secondary" onClick={onReload}>
            Reload
          </Button>
        ) : undefined
      }
    />
  );
}
